import { useEffect, useState } from 'react'
import { useGetFromSessionStorage } from '../use-session-storage'
import { localiseURL } from '../../utils/localiseURL'
import useTranslate from '../useTranslate'

export function useConversionCTA(locale: string) {
  const [conversionCTA, setConversionCTA] = useState({ url: '', text: '' })
  const { translate } = useTranslate()
  const [getFromSessionStorage] = useGetFromSessionStorage()
  const companySize = getFromSessionStorage('company-size')

  const setValue = () => {
    let CTAData = { url: localiseURL('/pricing', locale), text: translate('See our solutions') }
    if (companySize) {
      switch (companySize.replace(/"/g, '')) {
        case '9':
          CTAData = {
            url: localiseURL('/pricing?tab=1', locale),
            text: translate('See our solutions'),
          }
          break
        default:
          CTAData = {
            url: localiseURL('/book-custom-demo', locale),
            text: translate('Book a custom demo'),
          }
          break
      }
    }
    setConversionCTA(CTAData)
  }

  useEffect(() => {
    setValue()
  }, [])

  return [conversionCTA, setValue] as const
}
